import { MiniMap, useReactFlow } from '@xyflow/react';
import { Locate, Minus, Plus } from 'lucide-react';
import { useQuadro } from '../../application/dependencias';
import type { NoQuadro } from './montar-nos';

const corNoMinimapa = (no: NoQuadro) => (no.type === 'grupo' ? `color-mix(in srgb, ${no.data.estado.cor} 35%, white)` : 'transparent');

/** Minimapa, zoom e "Ajustar" no canto inferior direito, como na referência A. */
export function Controles() {
  const { zoomIn, zoomOut, fitView } = useReactFlow();
  const zoom = useQuadro((s) => s.zoom);
  return (
    <div className="controles">
      <MiniMap<NoQuadro>
        className="controles__minimapa"
        nodeColor={corNoMinimapa}
        nodeBorderRadius={12}
        maskColor="rgba(247, 246, 242, 0.55)"
        pannable
        zoomable
        ariaLabel="Minimapa do quadro"
      />
      <div className="controles__barra">
        <div className="controles__zoom">
          <button type="button" onClick={() => zoomOut({ duration: 200 })} aria-label="Afastar">
            <Minus size={18} />
          </button>
          <span aria-live="polite">{Math.round(zoom * 100)}%</span>
          <button type="button" onClick={() => zoomIn({ duration: 200 })} aria-label="Aproximar">
            <Plus size={18} />
          </button>
        </div>
        <button type="button" className="controles__ajustar" onClick={() => fitView({ duration: 300, padding: 0.08 })}>
          <Locate size={18} aria-hidden /> Ajustar
        </button>
      </div>
    </div>
  );
}
